<onyx-divider variant="modal" edge="top"></onyx-divider>

<section>
  <onyx-information-heading>
    {{ `${I18N}.isOrderPaid` | translate }}
  </onyx-information-heading>

  @let isWaitingForPayment =
    order().status.value === OrderStatus.WAITING_FOR_PAYMENT;
  <app-order-modal-payment-form
    [order]="order()"
    [form]="form"
    [mode]="OnyxFormMode.ADD"
    (partiallyPaidChanged)="isPartiallyPaid.set($event)"
  ></app-order-modal-payment-form>

  <onyx-button
    color="green"
    [spinner]="loading()"
    (click)="!loading() ? submit() : null"
  >
    {{
      (isWaitingForPayment
        ? `${I18N}.${isPartiallyPaid() ? 'markAsPartiallyPaid' : 'markAsPaid'}`
        : 'labels.save'
      ) | translate
    }}
  </onyx-button>
</section>

@if (isWaitingForPayment) {
  @let payment = order().payment;
  <app-contractor-shipping-methods
    [invoice]="payment.contractorInvoice"
    [invoiceDocuments]="payment.contractorInvoiceDocuments"
    variant="s"
  ></app-contractor-shipping-methods>
}

@if (isPartiallyPaid() && order().payment.history.length) {
  <app-order-modal-payments-history
    [order]="order()"
  ></app-order-modal-payments-history>
}

<onyx-divider variant="modal" edge="bottom"></onyx-divider>
